
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpClient, userManager, useAppAuth } from '../../logic/imports';



export const LoginPage: React.FC = () => {
    const { login, isAuthenticated, isLoading } = useAppAuth();
    const [isError, setIsError] = React.useState(false);
    const [errorMsg, setErrorMsg] = React.useState<string | null>(null);
    const navigate = useNavigate();

    // Reset error state on mount and whenever isAuthenticated becomes false (prevents stale error after logout)
    useEffect(() => {
        if (!isAuthenticated) {
            setIsError(false);
            setErrorMsg(null);
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (isAuthenticated) {
            (async () => {
                try {
                    const authMode = process.env.REACT_APP_AUTH_MODE?.trim();
                    const isDevBypass = authMode === 'dev-bypass';

                    if (!isDevBypass) {
                        await httpClient.auth0Callback();
                        console.log('Auth0 callback handled successfully, loading user data...');
                    }

                    await userManager.load();
                    console.log('User data loaded:', userManager.data);

                    const tosAccepted = (userManager.data.tosVersion ?? 0) > 0;
                
                    // TOS already accepted, check if valid Public secret is linked
                    if (tosAccepted) {
                        // if (profileManager.data.) { // TODO fix this when we're tracking brokerage linking status
                        //     await portfolioManager.initSession(profileManager.data.userId);
                        // }
                        navigate('/dashboard');
                    } 
                    // Redirect to TOS acceptance page
                    else {
                        navigate('/login/tos');
                    }
                } catch (err) {
                    handleConnectionError(err);
                }
            })();
        }
    }, [isAuthenticated, navigate]);

    const handleLogin = async () => {
        setIsError(false); // Reset error state on new attempt
        try {
            await login();
        } catch (err) {
            handleConnectionError(err);
        }
    };

    const handleConnectionError = (error: any) => {
        console.error('Connection error:', error);
        setIsError(true);
        // Try to extract a useful error message
        let msg = 'Login failed. Please check that your backend is running and dev-login is enabled.';
        if (error && typeof error === 'object') {
            if (error.message) msg += `\n${error.message}`;
            if (error.response && error.response.data && error.response.data.message) {
                msg += `\n${error.response.data.message}`;
            }
        }
        setErrorMsg(msg);
    }

    const buttonMessage = isError ? 'Login failed. See details below.'
        : isLoading || isAuthenticated ? 'Loading...' : 'Login';

    const buttonStyle: React.CSSProperties = {
        width: '250px',
        fontSize: '18px',
        borderColor: isError ? '#ff3f3fff' : undefined
    }

    return (
        <div className="page">
            <div
                className="panel panel--clear"
                style={{ 
                    width: '80%',
                    maxWidth: '500px',
                    borderWidth: '0'
            }}>
                <h1 style={{textAlign: 'center'}}>
                    Welcome!
                </h1>
                <br />
                <p style={{textAlign: 'left'}}>
                    This app provides advanced trading features for your Public.com brokerage account.<br/><br/>
                    Features include:
                </p>
                <ul>
                    <li>Configurable buy/sell orders for options</li>
                    <li>Trailing stop loss for options</li>
                    <li>Quick-purchase options</li>
                    <li>More coming soon</li>
                </ul>
                <br /><br />
                <button
                    className="button button--green"
                    style={buttonStyle}
                    onClick={handleLogin}
                    disabled={isLoading || isAuthenticated}
                >
                    {buttonMessage}
                </button>
                {isError && errorMsg && process.env.NODE_ENV === 'development' && (
                    <div style={{ color: '#ff3f3f', marginTop: 16, whiteSpace: 'pre-line', fontSize: 14 }}>
                        {errorMsg}
                    </div>
                )}
            </div>
        </div>
    );
};